import React from "react";
import "./Footer.css";
import { AiOutlineInstagram } from "react-icons/ai";
import { IoLogoWhatsapp, IoLogoFacebook } from "react-icons/io5";
import { BsArrowUpShort } from "react-icons/bs";

const Footer = () => {
  //Show Scroll Up
  function scrollUp() {
    const scrollTop = document.getElementById("scroll-up");
    if (this.scrollY >= 560) {
      scrollTop.classList.add("show-scroll");
    } else {
      scrollTop.classList.remove("show-scroll");
    }
  }
  window.addEventListener("scroll", scrollUp);
  return (
    <>
      <footer className="footer" id="footer">
        <div className="footer__bg">
          <div className="footer__container container grid">
            <div className="">
              <h1 className="footer__title">Pradip</h1>
              <span className="footer__subtitle">MERN Stack developer</span>
            </div>
            <ul className="footer__links">
              <li className="">
                <a href="#" className="footer__link">
                  Home
                </a>
              </li>
              <li className="">
                <a href="#projects" className="footer__link">
                  Projects
                </a>
              </li>

              <li className="">
                <a href="#about" className="footer__link">
                  About
                </a>
              </li>
            </ul>
            <div className="footer__socials">
              <a
                href="https://www.instagram.com/khamkar_pradip25/"
                className="footer__social"
                target="_blank"
              >
                <i>
                  <AiOutlineInstagram />
                </i>
              </a>
              <a
                href="https://wa.me/7350403908"
                target="_blank"
                className="footer__social"
              >
                <i>
                  <IoLogoWhatsapp />
                </i>
              </a>
              <a href="#footer" className="footer__social">
                <i>
                  <IoLogoFacebook />
                </i>
              </a>
            </div>
          </div>
          <p className="footer__copy">&#169; Pradip Khamkar</p>
        </div>
      </footer>
      <a href="#" className="scrollup" id="scroll-up">
        <i className="scrollup__icon">
          <BsArrowUpShort />
        </i>
      </a>
    </>
  );
};

export default Footer;
